(function (window) {
  /**
   * @class
   * @extends mkE.Base
   */
  const SearchList = Class(
    /**
     * @lends {SearchList#}
     */
    {
      /** @type {GeolocationPosition} */
      _userLocation: null,
      /** @type {DR.events.Search} */
      _mSearchEvents: undefined,
      _placeholders: [],
      /**
       *
       * @param {Url} url
       * @param {DR.events.GetFilter} method
       * @param {Function} drawMap
       * @param {Object} par
       * @private
       */
      __construct (url, method, drawMap, par) {
        this.par = par;
        this.url = url;
        this.drawMap = drawMap;
        this.node = mkE({
          tag: 'div',
          className: 'events-list',
          els: [
            this._search = new T.SearchEvents.AutoComplete({
              onChange: this.onSearchChange,
              kw: this.url.get.v('kw') || null,
              tag: this.url.get.v('tag') || null,
              switchToMapButton: this.drawMap
            }),
            this._filter = new T.SearchEvents.Filter({
              onChange: this.onFilterChange,
              transportType: this.url.get.v('transportType') ? this.url.get.v('transportType').split(',') : null,
              country: this.url.get.v('country') || D.LANG,
              sortType: this.url.get.v('sortType') || DR.events.Search.SORTTYPE_POPULARITY,
              method: method
            }),
            {
              tag: 'div',
              className: 'events-list-wrapper',
              els: [
                this._eventsFeaturedNode = mkE({
                  tag: 'div',
                  className: 'container events-featured'
                }),
                this._eventsHeaderNode = mkE({
                  tag: 'div',
                  className: 'container events-header'
                }),
                this._eventsListNode = mkE({
                  tag: 'div',
                  className: 'container events-search'
                }),
                {
                  tag: 'div',
                  className: 'events-white-space'
                },
                {
                  tag: 'a',
                  className: 'button button-pink button-draw-map',
                  onclick: () => {
                    this.drawMap();
                  },
                  els: [
                    D.CSS.brTablet ? '' : D.Lang.get('events.list.go-to-map'),
                    D.svgIcon('map')
                  ]
                }
              ]
            },
            {
              tag: 'div',
              className: 'container button-container load_more',
              els: [
                this._loadMoreNode = mkE({
                  tag: 'a',
                  className: 'button button-turquoise',
                  onclick: this._loadMore,
                  text: D.Lang.get('load_more'),
                  style: {
                    display: 'none'
                  }
                })
              ]
            }
          ]
        });
      },
      onFilterChange () {
        this.search();
      },
      onSearchChange () {
        this.search();
      },
      search () {
        this._userLocation = null;
        if (this._filter.getSortType() === DR.events.Search.SORTTYPE_DISTANCE) {
          this._drawPlaceholders(true);
          navigator.geolocation.getCurrentPosition(
            position => {
              this._userLocation = position;
              this._onSearch();
            },
            error => {
              this._filter.setSortType(DR.events.Search.SORTTYPE_POPULARITY);
            },
            {
              enableHighAccuracy: true,
              timeout: 5000,
              maximumAge: 0
            }
          );
        } else {
          this._onSearch();
        }
      },
      _onSearch: function () {
        let firstLoad = true;
        if (this._mSearchEvents) {
          if (this._mSearchEvents.processing) {
            return;
          }
          firstLoad = false;
        }
        const m = new DR.events.Search();
        this._mSearchEvents = m;
        m.select = [
          new DR.events.select.Event().id().title().image().showResults().startTime().endTime().seoTitle()
            .description().hasImage().status().description().settings().ticket().hasLandingImage().landingImage()
            .hasTeam().userRating().stats().hasEnded().isNewGame(),
          new DR.roadgames.select.Image().original().large().medium()
        ];
        if (this.par?.list?.featured !== false && firstLoad) {
          m.select.push(new DR.events.select.SearchRe().events().featuredEvent());
        } else {
          m.select.push(new DR.events.select.SearchRe().events());
        }
        m.onLoad = this._mSearchEventsRe;
        m.pg = 1;
        m.count = this.par?.list?.count || 20;
        m.sortType = this._filter.getSortType();
        m.transportType = this._filter.getTransportType();
        m.country = this._filter.getCountry();
        m.tag = this._search.valueTag();
        m.kw = this._search.value() || null;
        if (this._userLocation) {
          m.userLocation = new DR.roadgames.struct.Coordinates();
          m.userLocation.latitude = this._userLocation.coords.latitude;
          m.userLocation.longitude = this._userLocation.coords.longitude;
        }
        this._drawPlaceholders(true);
        m.call();
        Url.replace(this._getUrl().toUrl());
      },
      _drawPlaceholders (clear) {
        if (clear) {
          clearNode(this._eventsListNode);
        }
        const count = this.par?.list?.count || 20;
        for (let i = 0; i < count; i++) {
          this._placeholders.push(new T.ListEvent().append(this._eventsListNode));
        }
      },
      _removePlaceholders () {
        for (let i = 0; i < this._placeholders.length; i++) {
          const placeholder = this._placeholders[i];
          placeholder.remove();
        }
        this._placeholders = [];
      },
      _getUrl (loadMore) {
        const get = new Get(D.url('/events'));
        get.add('pg', this._mSearchEvents.pg + (loadMore ? 1 : 0));
        get.add('sortType', this._mSearchEvents.sortType);
        if (this._mSearchEvents.transportType && this._mSearchEvents.transportType.length < 3) {
          get.add('transportType', this._mSearchEvents.transportType.join(','));
        }
        if (this._mSearchEvents.country) {
          get.add('country', this._mSearchEvents.country);
        }
        if (this._mSearchEvents.tag) {
          get.add('tag', this._mSearchEvents.tag);
        }
        if (this._mSearchEvents.kw) {
          get.add('kw', this._mSearchEvents.kw);
        }
        return get;
      },
      _mSearchEventsRe () {
        this._removePlaceholders();
        const m = this._mSearchEvents;
        if (m.pg === 1) {
          clearNode(this._eventsListNode);
          if (this._mSearchEvents.re.featuredEvent) {
            clearNode(this._eventsFeaturedNode);
            this._featuredEvent = new T.FeaturedEvent('events-new', this._mSearchEvents.re.featuredEvent).append(this._eventsFeaturedNode);
          } else if (this._featuredEvent) {
            addClassName(this._eventsFeaturedNode, 'hide');
            this._featuredEvent = null;
          }
          clearNode(this._eventsHeaderNode);
          if (m.re.events.length) {
            if (!m.tag && !m.kw && !this.par?.list?.simpleHeader) {
              mkE({
                tag: 'div',
                className: 'h2',
                text: D.Lang.get(
                  'events.list.title.' + m.sortType + '.' + (m.transportType === null ? 'all' : m.transportType.sort().join('-')))
              }).append(this._eventsHeaderNode);
              mkE({
                tag: 'p',
                text: D.Lang.get(
                  'events.list.descr.' + m.sortType + '.' + (m.transportType === null ? 'all' : m.transportType.sort().join('-')))
              }).append(this._eventsHeaderNode);
            }
          } else {
            const nothing = mkE({
              tag: 'div',
              className: 'h2',
              text: D.Lang.get('events.list.title.nothing')
            }).append(this._eventsHeaderNode);
            nl2br(nothing);
          }
        }
        let trackList = [];
        if (m.re.events.length) {
          for (let i = 0; i < m.re.events.length; i++) {
            const listItem = m.re.events[i];
            new T.ListEvent(listItem).append(this._eventsListNode);
            trackList.push({
              item_id: listItem.id,
              item_name: listItem.title,
              item_url: D.url('/event/' + listItem.seoTitle, null, true),
              item_image_url: listItem.hasImage ? listItem.image.large : null
            });
          }
        } else if (m.pg === 1 && m.re.recommendedEvents) {
          for (let i = 0; i < m.re.recommendedEvents.length; i++) {
            const listItem = m.re.recommendedEvents[i];
            new T.ListEvent(listItem).append(this._eventsListNode);
          }
        }
        this._loadMoreNode.style.display = m.re.events.length > 0 && m.re.events.length >= m.count ? '' : 'none';
        if (trackList) {
          D.gtag('view_item_list', {
            ecommerce: {
              items: trackList
            }
          });
        }
      },
      _loadMore () {
        if (this._mSearchEvents.processing) {
          return false;
        }
        this._mSearchEvents.pg++;
        this._drawPlaceholders(false);
        this._mSearchEvents.call();
        return false;
      }
    },
    mkE.Base
  );

  T.EventsSearchList = SearchList;

})(window);
